const formatGroupError = (error, groupName, action = "create") => {
    if (error.message.includes("invalid name")) {
        return `Cannot ${action} a group with the name <b>${groupName}</b>. Try using another name.`;
    }
    return error.message;
};

// Extracts the server-side error correlation code (e.g. "UE-1779309164655") from an
// RMIWebSocketException payload. Returns null when no code is present.
const extractUECode = error => {
    if (!error) return null;
    const message = typeof error === "string" ? error : error.message || "";
    const match = message.match(/UE-\d+/);
    return match ? match[0] : null;
};

export { formatGroupError, extractUECode };
